export default __webpack_public_path__ + "static/media/error-modal-bg.45df5e17.svg";